import React from 'react';
import { BrowserRouter as Router, Route, Routes, useLocation } from 'react-router-dom';
import { trackEvent } from './utils/bridge.js';

import "./App.css"
import MenComponent from "./components/mens.js";
import FaqComponent from "./components/faqs.js";
import AssessmentFunnel from "./pages/AssessmentFunnel.js";
import TestimonialComponent from './components/testimonials.js';
import FormComponent from './components/menimagesform.js';
import AuthEntrypage, { AuthAdd } from './components/auth.js';
import RegistrationSuccess from './components/registrationucess.js';
import IndexPage from './pages/IndexPage.js';
import IntakeForm from './pages/IntakeForm.js';
import Terms from './pages/Terms.js';
import ReCAPTCHA from 'react-google-recaptcha';
import PrivacyPolicy from './pages/PrivacyPolicy.js';
import TermsAndConditions from './pages/TermsAndConditions.js';
import ProfileGenerator from './components/ai_profiles.js';
import ReportIssueButton from './components/ReportIssueButton.js';
import SupportChatAdmin from './pages/SupportChatAdmin.js';
import FinancialDashboard from './pages/FinancialDashboard.js';
import AdsDataDashboard from './pages/AdsDataDashboard.js';
import BridgeStatsDashboard from './pages/BridgeStatsDashboard.js';
import AssessmentEventsDashboard from './pages/AssessmentEventsDashboard.js';
import TestimonialsAdmin from './pages/TestimonialsAdmin.js';
import MaintenanceToggle from './pages/MaintenanceToggle.js';
import AuthCookieAdmin from './pages/AuthCookieAdmin.js';
import HomepageIntroVideoAdmin from './pages/HomepageIntroVideoAdmin.js';
import ScheduledJobsRunner from './pages/ScheduledJobsRunner.js';
import MessageTasksDashboard from './pages/MessageTasksDashboard.js';
import ScheduleMessages from './pages/ScheduleMessages.js';
import BulkPackageChange from './pages/BulkPackageChange.js';
import HubbyDraftsAdmin from './pages/HubbyDraftsAdmin.js';
import ConfirmedHubbyDrafts from './pages/ConfirmedHubbyDrafts.js';
import AiConversationsAdmin from './pages/AiConversationsAdmin.js';
import NotificationsAdmin from './pages/NotificationsAdmin.js';
import MaintenanceBanner from './components/MaintenanceBanner.js';
import MaintenanceGate from './components/MaintenanceGate.js';
import NotFound from './pages/NotFound.js';

import Signup, 
    {
        ForgotPassword, GoogleEnabledLogin, SirriEnabledLogin, MenDashboard,
        MenSignupPage, MensMessagingDashboard, PurgatoryActivations,
        ArchivedProfiles, DeletedProfiles, Resettingpassword
    } from './components/signup.js'
import WomenInfoDashboard from './components/WomenInfoDashboard.js';

import LoginPlease, 
    { 
        EditsSuccessful, VerificationFailed, VerificationSuccessful 
    } from './components/loginsignupplease.js';
import { 
    malequestions, femalequestions 
} from './components/misc.js';

import Profile, {
    LoginCheckComponent, PersonalProfile, AdminCheckComponent
} from './components/profile.js';
import HowItWorks, { 
    HowItWorksSpecificCarousel 
} from './pages/HowItWorks.js';
import AllChats, {
    SpecificPersonsChat, SpecificPersonsChatAsMan
} from './pages/Chats.js';
import ActivationProfile from './pages/ActivationProfile.js';
import PassResetLinkToBeReceived, { 
    PassResetSuccessful 
} from './components/forgottenpassword.js';
import { GoogleOAuthProvider } from '@react-oauth/google';

const routeEvents = [
    [/^\/$/, 'homepage_visit'],
    [/^\/html\/authcode\.html$/, 'signup_auth_page_visit'],
    [/^\/(signup|html\/signup_form\.html)$/, 'signup_form_visit'],
    [/^\/login$/, 'login_page_visit'],
    [/^\/forgottenpassword$/, 'forgot_password_page_visit'],
    [/^\/resetpassword\//, 'reset_password_page_visit'],
    [/^\/terms$/, 'terms_page_visit'],
    [/^\/privacypolicy$/, 'privacy_policy_page_visit'],
    [/^\/termssandconditions$/, 'terms_and_conditions_page_visit'],
    [/^\/faq$/, 'faq_page_visit'],
    [/^\/alltestimonials$/, 'testimonials_page_visit'],
    [/^\/howitworks$/, 'how_it_works_page_visit'],
    [/^\/howitworks\//, 'how_it_works_carousel_visit'],
    [/^\/men$/, 'men_page_visit'],
    [/^\/registrationsuccess$/, 'signup_registration_success_viewed'],
    [/^\/loginplease$/, 'loginplease_page_visit'],
    [/^\/editssuccessful$/, 'profile_edit_success_page_visit'],
    [/^\/verificationsuccessful$/, 'verification_success_page_visit'],
    [/^\/verificationfailed$/, 'verification_failed_page_visit'],
    [/^\/profile\//, 'profile_page_visit'],
    [/^\/(personalprofile|myprofile|profilen|myprofilen)\//, 'personal_profile_page_visit'],
    [/^\/sirri_api\/men_images_form$/, 'admin_male_image_form_visit'],
    [/^\/sirri_api\/activations$/, 'admin_activations_page_visit'],
    [/^\/sirri_api\/(activation_profile|activation_email)\//, 'admin_activation_profile_visit'],
    [/^\/sirri_api\/archived_profiles$/, 'admin_archived_profiles_page_visit'],
    [/^\/sirri_api\/deleted_profiles$/, 'admin_deleted_profiles_page_visit'],
    [/^\/sirri_api\/womeninfo$/, 'admin_women_info_page_visit'],
    [/^\/sirri_api\/addauth$/, 'admin_auth_codes_page_visit'],
    [/^\/sirri_api\/support_chats$/, 'admin_support_dashboard_visit'],
    [/^\/sirri_api\/mensdashboard$/, 'admin_mens_dashboard_visit'],
    [/^\/sirri_api\/mensmessagingdashboard$/, 'admin_mens_messaging_dashboard_visit'],
    [/^\/sirri_api\/mensignup\.html$/, 'admin_male_signup_page_visit'],
    [/^\/sirri_api\/perfil_generador$/, 'admin_ai_profile_generator_visit'],
    [/^\/sirri_api\/chats$/, 'admin_chats_page_visit'],
    [/^\/sirri_api\/chat\//, 'admin_specific_chat_page_visit'],
    [/^\/sirri_api\/chatasman\//, 'admin_send_as_man_page_visit'],
    [/^\/sirri_api\/financial_dashboard$/, 'admin_financial_dashboard_visit'],
    [/^\/sirri_api\/ads_data$/, 'admin_ads_data_dashboard_visit'],
    [/^\/sirri_api\/bridge_stats$/, 'admin_bridge_stats_dashboard_visit'],
    [/^\/sirri_api\/assessment_events$/, 'admin_assessment_events_dashboard_visit'],
    [/^\/sirri_api\/maintenance$/, 'admin_maintenance_page_visit'],
    [/^\/sirri_api\/homepage_intro_video$/, 'admin_homepage_intro_video_visit'],
    [/^\/sirri_api\/scheduled_jobs$/, 'admin_scheduled_jobs_page_visit'],
    [/^\/sirri_api\/message_tasks$/, 'admin_message_tasks_page_visit'],
    [/^\/sirri_api\/schedule_messages$/, 'admin_schedule_messages_page_visit'],
    [/^\/sirri_api\/bulk_package_change$/, 'admin_bulk_package_change_page_visit'],
    [/^\/sirri_api\/hubby_drafts$/, 'admin_hubby_drafts_page_visit'],
    [/^\/sirri_api\/confirmed_hubby_drafts$/, 'admin_confirmed_hubby_drafts_page_visit'],
    [/^\/sirri_api\/ai_conversations$/, 'admin_ai_conversations_page_visit'],
    [/^\/sirri_api\/notifications$/, 'admin_notifications_page_visit'],
];

function PageVisitTracker() {
    const location = useLocation();

    React.useEffect(() => {
        const pathname = location.pathname;
        const match = routeEvents.find(([pattern]) => pattern.test(pathname));
        trackEvent(match ? match[1] : 'not_found_page_visit', { path: pathname });
    }, [location.pathname]);

    return null;
}

function ReportIssueButtonWrapper() {
    const location = useLocation();
    const hostname = window.location.hostname || "";
    const isExpatElite = hostname.includes("expatelitesingles.com") || hostname === "localhost" || hostname === "127.0.0.1";

    if (
        location.pathname === '/'
        || (hostname.includes('penzi-halisi.com') && ['/privacypolicy', '/termssandconditions'].includes(location.pathname.replace(/\/+$/, '')))
        || (isExpatElite && location.pathname === '/login')
        || /^\/(personalprofile|myprofile|myprofilen)\//.test(location.pathname)
    ) {
        return null;
    }

    return <ReportIssueButton />;
}

function PenziWhatsAppButtonWrapper() {
    const location = useLocation();
    const hostname = window.location.hostname || "";
    const isPenziHalisi = hostname.includes("penzi-halisi.com");
    const isLoginRoute = location.pathname === '/login';

    if (!isPenziHalisi || !isLoginRoute) {
        return null;
    }

    const positionClass = 'bottom-16';

    return (
        <a
            className={`fixed ${positionClass} left-4 z-50 flex items-center gap-2 rounded bg-gradient-to-r from-[#149845] to-[#24c965] px-3 py-2 font-bold text-white shadow-lg hover:from-[#128d40] hover:to-[#28d36d]`}
            href="https://wa.me/447456722140"
            aria-label="Open WhatsApp"
            onClick={() => trackEvent('whatsapp_clicked', { source: 'penzi_floating_whatsapp', path: location.pathname })}
        >
            <svg className="h-5 w-5" viewBox="0 0 32 32" aria-hidden="true" fill="currentColor"><path d="M16 3A12.8 12.8 0 0 0 5 22.3L3.4 29l6.9-1.8A12.9 12.9 0 1 0 16 3Zm0 23.4c-1.9 0-3.7-.5-5.3-1.4l-.8-.5-4.1 1.1 1.1-4-.5-.8A10.5 10.5 0 1 1 16 26.4Zm5.8-7.9c-.3-.2-1.9-.9-2.2-1-.3-.1-.5-.2-.7.2-.2.3-.8 1-1 1.2-.2.2-.4.2-.7.1-2-.9-3.4-1.8-4.7-4-.4-.7.4-.7 1.1-2.2.1-.2 0-.5 0-.7l-.5-1.2c-.3-.6-.5-.5-.7-.5h-.6c-.2 0-.6.1-.9.4-.3.3-1.2 1.2-1.2 2.9s1.3 3.4 1.4 3.6c.2.2 2.5 3.8 6 5.3.8.4 1.5.6 2 .7.8.3 1.6.2 2.2.1.7-.1 1.9-.8 2.2-1.5.3-.8.3-1.4.2-1.5-.1-.2-.3-.3-.6-.5Z"/></svg>
            WhatsApp
        </a>
    );
}


function GoogleAuthWrapper({ children }) {
    const googleClientId = process.env.REACT_APP_GOOGLE_CLIENT_ID || "550857564343-bo0d11fnt845romhgb947phqqvgmdfs0.apps.googleusercontent.com";

    if (!googleClientId) {
        return <>{children}</>;
    }

    return <GoogleOAuthProvider clientId={googleClientId}>{children}</GoogleOAuthProvider>;
}

function App() {
    return (
        <GoogleAuthWrapper>
        <Router>
            <PageVisitTracker />
            <MaintenanceGate>
            <ReportIssueButtonWrapper />
            <PenziWhatsAppButtonWrapper />
            <MaintenanceBanner />
            <Routes>
                <Route path="/" element={<IndexPage />} />
                <Route path="/assessment" element={<AssessmentFunnel key="assessment-landing" />} />
                <Route path="/assessment/private" element={<AssessmentFunnel key="assessment-private" privateFlow />} />
                <Route path="/howitworks" element={<HowItWorks />} />
                <Route path="/howitworks/:thecarousel" element={<HowItWorksSpecificCarousel />} />
                <Route path="/login" element={<GoogleEnabledLogin url="/api/passcheck" />} />
                <Route path="/sirri_api/login" element={<SirriEnabledLogin url="/api/passcheck" />} />
                <Route path="/recaptcha" element={<ReCAPTCHA sitekey={process.env.REACT_APP_SITE_KEY} />} />
                <Route path="/forgottenpassword" element={<ForgotPassword url="/api/forgottenpassword" />} />
                <Route path="/resetpassword/:token" element={<Resettingpassword url="/api/resettingpassword" />} />
                <Route path="/resetpasswordsuccess" element={<PassResetSuccessful />} />
                <Route path="/forgottenpasswordsubmitted" element={<PassResetLinkToBeReceived />} />
                <Route path="/forgottenpassword" element={<ForgotPassword url="/api/forgottenpassword" />} />
                <Route path="/men" element={<MenComponent />} />
                <Route path="/alltestimonials" element={<TestimonialComponent />} />
                <Route path="/faq" element={<FaqComponent />} />
                <Route path="/registrationsuccess" element={<RegistrationSuccess />} />
                <Route path="/loginplease" element={<LoginPlease />} />
                <Route path="/editssuccessful" element={<EditsSuccessful />} />

                <Route path="/html/signup_form.html" element={<Signup url="/api/store_data" allquestions={femalequestions} gender="Female" allrequired={true}/>} />
                <Route path="/signup" element={<Signup url="/api/store_data" allquestions={femalequestions} gender="Female" allrequired={true}/>} />
                <Route path="/intake-form" element={<IntakeForm />} />
                <Route path="/html/authcode.html" element={<AuthEntrypage />} />
                <Route path="/terms" element={<Terms />} />
                <Route path="/termsofservice" element={<Terms />} />
                <Route path="/privacypolicy" element={<PrivacyPolicy />} />
                <Route path="/termssandconditions" element={<TermsAndConditions />} />

                <Route path="/profile/:profileid" element={<Profile authenticate={true} />} />
                <Route path="/personalprofile/:profileid" element={<PersonalProfile authenticate={true} />} />
                <Route path="/myprofile/:profileid" element={<PersonalProfile authenticate={true} />} />
                <Route path="/profilen/:profileid" element={<Profile authenticate={false} />} />
                <Route path="/myprofilen/:profileid" element={<PersonalProfile authenticate={false} />} />

                <Route path="/sirri_api/men_images_form" element={<AdminCheckComponent thecomponent={<FormComponent />}/>} />
                <Route path="/sirri_api/mensdashboard" element={<AdminCheckComponent thecomponent={<MenDashboard />}/>} />
                <Route path="/sirri_api/mensmessagingdashboard" element={<AdminCheckComponent thecomponent={<MensMessagingDashboard />}/>}/>
                <Route path="/sirri_api/mensignup.html" element={<AdminCheckComponent thecomponent={<MenSignupPage questions={malequestions} gender="Male"/>} />}/>
                <Route path="/sirri_api/perfil_generador" element={<AdminCheckComponent thecomponent={<ProfileGenerator allquestions={malequestions} allrequired={true} url="/api/sirri_api/backend/perfil_generador" signupurl="/api/sirri_api/store_data"/>}/>}/>

                <Route path="/sirri_api/activations" element={<AdminCheckComponent thecomponent={<PurgatoryActivations />}/>} />
                <Route path="/sirri_api/activation_profile/:email" element={<AdminCheckComponent thecomponent={<ActivationProfile />}/>} />
                <Route path="/sirri_api/activation_email/:email" element={<AdminCheckComponent thecomponent={<ActivationProfile />}/>} />
                <Route path="/sirri_api/archived_profiles" element={<AdminCheckComponent thecomponent={<ArchivedProfiles />}/>} />
                <Route path="/sirri_api/deleted_profiles" element={<AdminCheckComponent thecomponent={<DeletedProfiles />}/>} />
                <Route path="/sirri_api/womeninfo" element={<AdminCheckComponent thecomponent={<WomenInfoDashboard />}/>} />
                <Route path="/sirri_api/addauth" element={<AdminCheckComponent thecomponent={<AuthAdd/>}/>} />

                <Route path="/sirri_api/support_chats" element={<AdminCheckComponent thecomponent={<SupportChatAdmin />} />} />
                <Route path="/sirri_api/financial_dashboard" element={<AdminCheckComponent thecomponent={<FinancialDashboard />} />} />
                <Route path="/sirri_api/ads_data" element={<AdminCheckComponent thecomponent={<AdsDataDashboard />} />} />
                <Route path="/sirri_api/bridge_stats" element={<AdminCheckComponent thecomponent={<BridgeStatsDashboard />} />} />
                <Route path="/sirri_api/assessment_events" element={<AdminCheckComponent thecomponent={<AssessmentEventsDashboard />} />} />
                <Route path="/sirri_api/testimonials" element={<AdminCheckComponent thecomponent={<TestimonialsAdmin />} />} />
                <Route path="/sirri_api/maintenance" element={<AdminCheckComponent thecomponent={<MaintenanceToggle />} />} />
                <Route path="/sirri_api/homepage_intro_video" element={<AdminCheckComponent thecomponent={<HomepageIntroVideoAdmin />} />} />
                <Route path="/sirri_api/logout_everyone" element={<AdminCheckComponent thecomponent={<AuthCookieAdmin />} />} />

                <Route path="/sirri_api/scheduled_jobs" element={<AdminCheckComponent thecomponent={<ScheduledJobsRunner />} />} />
                <Route path="/sirri_api/message_tasks" element={<AdminCheckComponent thecomponent={<MessageTasksDashboard />} />} />
                <Route path="/sirri_api/schedule_messages" element={<AdminCheckComponent thecomponent={<ScheduleMessages />} />} />
                <Route path="/sirri_api/bulk_package_change" element={<AdminCheckComponent thecomponent={<BulkPackageChange />} />} />
                <Route path="/sirri_api/hubby_drafts" element={<AdminCheckComponent thecomponent={<HubbyDraftsAdmin />} />} />
                <Route path="/sirri_api/confirmed_hubby_drafts" element={<AdminCheckComponent thecomponent={<ConfirmedHubbyDrafts />} />} />
                <Route path="/sirri_api/ai_conversations" element={<AdminCheckComponent thecomponent={<AiConversationsAdmin />} />} />
                <Route path="/sirri_api/notifications" element={<AdminCheckComponent thecomponent={<NotificationsAdmin />} />} />

                <Route path="/sirri_api/chats" element={<AdminCheckComponent thecomponent={<AllChats />}/>} />
                <Route path="/sirri_api/chat/:email" element={<AdminCheckComponent thecomponent={<SpecificPersonsChat />}/>} />
                <Route path="/sirri_api/chatasman/:email" element={<AdminCheckComponent thecomponent={<SpecificPersonsChatAsMan />}/>} />
                
                <Route path="/verificationsuccessful" element={<VerificationSuccessful />} />
                <Route path="/verificationfailed" element={<VerificationFailed />} />
                
                <Route path="*" element={<NotFound />} />
            </Routes>
            </MaintenanceGate>
        </Router>
        </GoogleAuthWrapper>
    );
}

export default App;
